/* eslint-disable react/forbid-elements */
import * as React from 'react';
import * as styles from './styles.css';

export function PlayerIcon() {
  return (
    <svg
      className={styles['player_icon']}
      width="68"
      height="48"
      viewBox="0 0 68 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.3157 10.3527C67.3157 10.3527 66.653 5.65091 64.6109 3.57818C62.0256 0.861818 59.1252 0.850909 57.8 0.687273C48.2843 1.30046e-07 34.0109 0 34.0109 0H33.9783C33.9783 0 19.7048 1.30046e-07 10.1891 0.687273C8.8639 0.850909 5.96358 0.861818 3.37828 3.57818C1.3361 5.65091 0.673483 10.3527 0.673483 10.3527C0.673483 10.3527 -1.29493e-08 15.8727 -1.29493e-08 21.4036V26.5855C-1.29493e-08 32.1055 0.684345 37.6255 0.684345 37.6255C0.684345 37.6255 1.34696 42.3273 3.38914 44.4C5.97444 47.1164 9.37444 47.0291 10.8843 47.3127C16.3157 47.8364 34 48 34 48C34 48 48.2843 47.9782 57.8 47.2909C59.1252 47.1273 62.0256 47.1164 64.6109 44.4C66.653 42.3273 67.3157 37.6255 67.3157 37.6255C67.3157 37.6255 68 32.1055 68 26.5855V21.4036C68 15.8727 67.3157 10.3527 67.3157 10.3527Z"
        fill="#FC0D1C"
      />
      <path d="M26.9844 13.6689V32.8471L45.3531 23.2908L26.9844 13.6689Z" fill="#EAEAEA" />
    </svg>
  );
}
